import { z } from 'zod';

import type { Database } from '../../../lib/database.types';

export const COMPANY_COLORS = ['yellow', 'coral', 'olive', 'teal', 'lilac', 'rose'] as const;

export type CompanyColor = (typeof COMPANY_COLORS)[number];

const optionalUrl = z
  .string()
  .trim()
  .optional()
  .refine((value) => {
    if (!value) return true;
    try {
      const url = new URL(value);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
      return false;
    }
  }, 'כתובת אתר לא תקינה');

export const companySchema = z.object({
  name: z.string().trim().min(1, 'שדה חובה').max(120, 'עד 120 תווים'),
  initials: z.string().trim().max(4, 'עד 4 תווים').optional(),
  color: z.enum(COMPANY_COLORS),
  industry: z.string().trim().optional(),
  size: z.string().trim().optional(),
  website: optionalUrl,
  address: z.string().trim().optional(),
  notes: z.string().trim().max(2000, 'עד 2000 תווים').optional(),
});

export type CompanyInput = z.infer<typeof companySchema>;

type CompanyTableRow = Database['public']['Tables']['companies']['Row'];

export type CompanyRow = Pick<
  CompanyTableRow,
  | 'id'
  | 'name'
  | 'initials'
  | 'color'
  | 'industry'
  | 'size'
  | 'website'
  | 'address'
  | 'notes'
  | 'created_at'
  | 'updated_at'
>;
